<!--
  name : 김혜진
  desc : 개인정보취급방침 다이얼로그
  date : 2020-12-04
-->
<template>
  <v-dialog v-model="intgInfoPop" max-width="1200px" persistent>
    <v-card id="popStyle03">
      <!--팝업 제목-->
      <v-card-title class="title">
        개인정보처리방침
        <ul class="pattern_ulTxtBox">
          <li>
            <!--클릭시:시행중인 개인정보취급방침 보기 = true-->
            <span class="txt_txt02 poinTer" @click="click(0)"
              >시행중인 개인정보처리방침 보기</span
            >
          </li>
          <v-select class ="txt_txt04 poinTer"
            v-model="selectTerm"
            @change="changeTerm"
            :items="termCategory">
          </v-select>    
        </ul>
        <v-btn fab class="popBtnClose" @click="intgInfoPop = false"></v-btn>
      </v-card-title>
      <!--/팝업 제목-->
      <!--팝업 내용-->
      <v-card-text class="scrollYst popConH100-1row">
        <v-row no-gutters class="popCon scrollYst_con">
          <!--시행중인 개인정보취급방침 보기-->
          <v-col cols="12" class="protPage" v-if="step0 === true">
            <div class="prot_box">
              <ul class="agree_list">
                <li>
                  글로싸인엔터프라이즈는 정보주체의 개인정보 보호를 위해 
                  「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 
                  적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 
                </li>
                <li>
                  개인정보처리방침은 정부의 법률 및 지침의 변경과
                  글로싸인엔터프라이즈의 정책 변화에 따라 변경될 수 있고, 이에
                  따라 개인정보처리방침을 개정하는 경우 공지사항을 통하여 미리
                  공지하여 고객이 확인할 수 있도록 조치하고 있습니다.
                </li>
                <li>
                  글로싸인엔터프라이즈는 개인정보처리방침을 통하여 
                  개인정보가 어떠한 용도와 방식으로 이용되고 있으며 
                  개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드리고자 합니다.
                </li>
              </ul>
            </div>
            <h3 class="agree_h1">
              글로싸인엔터프라이즈 개인정보처리방침은 아래와 같은 내용을 담고
              있습니다.
            </h3>
            <ul class="agree_list">
              <li>
                <ul class="agree_in">
                  <li>1. 개인정보의 처리목적</li>
                  <li>2. 처리하는 개인정보 항목</li>
                  <li>3. 개인정보의 처리 및 보유기간</li>
                  <li>4. 개인정보의 제3자 제공</li>
                  <li>5. 개인정보처리의 위탁</li>
                  <li>6. 개인정보의 파기</li>
                  <li>7. 정보주체와 법정대리인의 권리·의무 및 행사방법</li>
                  <li>
                    8. 개인정보의 안정성 확보 조치
                  </li>
                  <li>9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</li>
                  <li>
                    10. 개인정보 보호책임자에 관한 사항
                  </li>
                  <li>11. 개인정보의 열람청구를 접수·처리하는 부서</li>
                  <li>12. 정보주체의 권익침해에 대한 구제방법</li>
                  <li>13. 개인정보 처리방침의 변경에 관한 사항</li>
                </ul>
              </li>
            </ul>
            <ul class="agree_list"> 
              <li>
                <h4 class="agree_h2">1. 개인정보의 처리목적</h4>
                <ul class="agree_in">
                  <li>
                    회사는 아래의 목적을 위해 개인정보를 처리합니다. <br />처리하고 있는 개인정보는 아래의 목적 이외의 용도로는 이용되지 않으며, 
                    이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
                  </li>
                  <li>
                    <span class="prot_txtb"
                      >가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른
                      요금정산</span
                    ><br />전자계약 서비스 이용시 필요한 정보전달 및 요금결제,
                    청구서 발송
                  </li>
                  <li>
                    <span class="prot_txtb">나. 회원 관리</span><br />회원제
                    서비스 이용 및 제한적 본인 확인제에 따른 본인확인, 개인
                    식별, 신용평가기관을 통한 실명확인, 연령제한 서비스의 제공,
                    부정이용방지와 비인가 사용 방지, 가입 의사 확인, 불만처리 등
                    민원처리, 고지사항 전달
                  </li>
                  <li>
                    <span class="prot_txtb">다. 마케팅 및 광고 활용</span
                    ><br />마케팅 및 광고 활용, 회원의 서비스 이용에 대한 통계,
                    통계학적 분석(회원의 업종별, 기업규모별, 지역별 통계분석 등)
                  </li>
                </ul>
              </li>
              <li>
								<h4 class="agree_h2">2. 처리하는 개인정보 항목</h4>
									<ul class="agree_in">
										<li>회사는 회원가입, 원활한 고객상담, 각종 서비스의 제공 등을 위해 필요한 최소한의 개인정보를 수집하고 있습니다.</li>
										<!-- 가. -->
										<li><span class="prot_txtb">가.	수집하는 개인정보의 항목</span><br/>
										<ul class="pt_mgl">
											<li>1) 수집하는 개인정보 유형 및 항목</li>
											<li>
                        <table class="term_tbl">
                          <colgroup>
                          <col style="width:20%"/>
                          <col style="width:10%"/>
                          </colgroup>
                          <tr>    
                          <td style="text-align:center">회원가입</td>
                          <td style="text-align:center">필수</td>  
                          <td>아이디, 비밀번호, 이름, 연락처, 주소, 상세주소, 이메일, 블록체인 비밀번호</td>
                          </tr>
                          <tr>
                          <td style="text-align:center" rowspan="2">유료 서비스 이용 관련 결제</td>
                          <td style="text-align:center">필수</td>
                          <td>
                            [신용카드] 카드사, 카드번호, CVC번호, 유효기간, 이름, 생년월일, 성별, 휴대전화번호, 주민등록번호(앞7자리), 결제비밀번호<br/>
                            [계좌이체] 예금주명, 주민/사업자번호, 금융기관, 계좌번호, 계좌비밀번호, 계좌구분, 주민번호(앞7자리), 사업자등록번호, 휴대폰번호, 생년월일(6자리), PIN<br/>
                            [무통장입금] 예금주명, 은행명, 입금자명<br/>
                            [휴대폰결제] 예금주명, 이동통신사, 휴대폰번호, 주민번호(앞7자리)
                          </td>
                          </tr>
                          <tr>
                          <td style="text-align:center">선택</td>
                          <td>
                            [신용카드] 이메일<br/>
                            [계좌이체] 이메일<br/>
                            [무통장입금] 휴대폰번호, 이메일<br/>
                            [휴대폰결제] 이메일
                          </td>
                          </tr>
                          <tr>
                          <td style="text-align:center" rowspan="2">도입문의</td>
                          <td style="text-align:center">필수</td>
                          <td>회사명, 이메일, 연락처, 문의내용</td>
                          </tr>
                          <tr>
                          <td style="text-align:center">선택</td>
                          <td>월 평균 계약건수</td>
                          </tr>
                        </table>
											</li>
											<li>2) 서비스 이용과정에서 아래와 같은 정보들이 자동 생성 및 수집</li>
											<li>- IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록</li>
										</ul>
										</li>
										<!-- 가. 끝 -->
										<li><span class="prot_txtb">나.	개인정보 수집방법</span><br/>
										<ul class="pt_mgl">
											<li>회사는 아래와 같은 방법으로 개인정보를 수집합니다.</li>
											<li>- 홈페이지 회원가입, 도입 문의 및 고객 응대 과정에서 수집, 서비스 이용 또는 처리과정에서 자동 혹은 수동으로 생성되어 수집</li>
										</ul>
										</li>
									</ul>
							</li>
              <li>
                <h4 class="agree_h2">3. 개인정보의 처리 및 보유기간</h4>
                <ul class="agree_in">
                  <li>
                    회사는 아래의 정보에 대하여 관계 법령에서 명시한 기간 동안 개인정보를 보유합니다. 
                    법령에 따른 개인정보 보유 및 이용기간 또는 정보주체로부터 
                    개인정보를 수집 시에 동의 받은 개인정보 보유 및 이용기간 내에서 
                    개인정보를 처리 보유합니다. <br />
                    <ul class="ag_mgl">
                      <li>
                        가. 본인확인에 관한 기록 <br />
                        - 보존 근거 : 정보통신망 이용촉진 및 정보보호 등에 관한
                        법률 <br />
                        - 보존 기간 : 6개월
                      </li>
                      <li>
                        나. 계약 또는 청약철회 등에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 5년
                      </li>
                      <li>
                        다. 대금결제 및 재화 등의 공급에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 5년
                      </li>
                      <li>
                        라. 소비자의 불만 또는 분쟁처리에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 3년<br />
                      </li>
                      <li>
                        마. 표시 광고에 관한 기록<br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률<br />
                        - 보존 기간 : 6개월<br />
                      </li>
                      <li>
                        바. 웹사이트 방문에 관한 기록<br />
                        - 보존 이유 : 통신비밀보호법<br />
                        - 보존 기간 : 3개월<br />
                      </li>
                      <li>
                        사. 보유기간을 정보주체에게 미리 고지하고 
                        그 보유기간이 경과하지 아니한 경우와 
                        개별적으로 정보주체의 동의를 받을 경우에는 약속한 기간 동안 보유
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">4. 개인정보의 제3자 제공</h4>
                <ul class="agree_in">
                  <li>
                    회사는 정보주체의 개인정보를 '1. 개인정보의 처리목적'에서 고지한 범위 내에서 개인정보를 이용하며, 동 
                    범위를 초과하여 이용하거나 타인 또는 타 기관에 제공 또는 공유하지 않습니다.
                  </li>
                  <li>
                    다만, 아래의 경우에는 예외적으로 정보주체의 동의 없이 개인정보를 제공할 수 있습니다.<br />
                    <ul class="ag_mgl">
                      <li>
                        가. 법령의 규정에 의거하거나, 수사상 목적으로 법령에
                        정해진 절차와 방법에 따라 관련기관의 요구가 있는 경우
                      </li>
                      <li>나. 정보주체가 사전에 동의한 경우</li>
                      <li>
                        다. 유료 서비스 제공에 따른 요금 결제를 위하여 필요한 경우
                      </li>
                      <li>라. 신용평가기관을 통한 본인확인에 필요한 경</li>
                      <li>
                        마. 통계처리, 학술연구, 시장조사 등을 위하여 필요한
                        경우에는 특정한 개인을 식별할 수 없는 형태로 가공하여
                        제공하는 경우
                      </li>
                      <li>
                        바. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  5. 개인정보처리의 위탁
                </h4>
                <ul class="agree_in">
                  <li>
                    ① 회사는 원활한 개인정보 업무처리를 위하여 아래와 같이 개인정보 처리업무를 위탁하고 있습니다.
                  </li>
                  <li>
                    <table class="term_tbl">
                      <colgroup>
                        <col style="width:30%" />
                        <col style="width:30%" />
                        <col style="width:40%" />
                      </colgroup>
                      <tr>
                        <th style="text-align:center" scope="col">수탁업체</th>
                        <th style="text-align:center" scope="col">위탁업무 내용</th>
                        <th style="text-align:center" scope="col">보유 및 이용기간</th>
                      </tr>
                      <tr>
                        <td style="text-align:center">코리아크레딧뷰로㈜</td>
                        <td style="text-align:center">본인인증 서비스</td>
                        <td style="text-align:center" rowspan="5">회원 탈퇴 시 혹은 위탁 계약 종료시까지</td>        
                      </tr>
                      <tr>
                        <td style="text-align:center">토스페이먼츠</td>
                        <td style="text-align:center">서비스 이용요금 결제 대행</td>
                      </tr>
                      <tr>
                        <td style="text-align:center">세종텔레콤</td>
                        <td style="text-align:center">문자 메시지 서비스</td>
                      </tr>
                      <tr>
                        <td style="text-align:center">비즈톡</td>
                        <td style="text-align:center">카카오톡 메시지 서비스</td>
                      </tr>
                      <tr>
                        <td style="text-align:center">시스원</td>
                        <td style="text-align:center">서비스 인프라 유지보수</td>
                      </tr>
                    </table>
                  </li>
                  <li>
                    ② 회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
                  </li>
                  <li>
                    ③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">6. 개인정보의 파기</h4>
                <ul class="agree_in">
                  <li>
                    회사는 원칙적으로 개인정보의 처리목적이 달성되면 지체 없이 파기합니다. <br/>
                    파기절차 및 방법은 아래와 같습니다.
                  </li>
                  <li>
                    <span class="prot_txtb">가. 파기절차</span><br />
                    <ul class="pt_mgl">
                      <li>
                        정보주체가 서비스 이용 등을 위해 입력한 정보는 목적이 달성된 후 
                        별도의 DB로 옮겨져 개인정보의 보유 및 이용기간에 따라 일정 기간 저장된 후 파기됩니다.<br/>
                        별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 
                        이외의 다른 목적으로 이용되거나 제공되지 않습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span class="prot_txtb">나. 파기방법</span><br />
                    <ul class="pt_mgl">
                      <li>
                        - 전자적 파일형태로 기록·저장된 개인정보는 기록을 재생할 수
                        없는 기술적 방법을 사용하여 삭제합니다.
                      </li>
                      <li>
                        - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을
                        통하여 파기합니다.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  7. 정보주체와 법정대리인의 권리·의무 및 행사방법
                </h4>
                <ul class="agree_in">
                  <li>
                    ① 정보주체는 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다. <br/>
                    다만, 서비스 제공을 위해 반드시 필요한 개인정보를 삭제하는 경우 서비스의 
                    일부 또는 전부 이용이 어려울 수 있습니다.
                  </li>
                  <li>
                    ② 권리 행사는 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 이에 대해 지체없이 조치하겠습니다.
                  </li>
                  <li>
                    ③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 
                    이 경우 “개인정보 처리 방법에 관한 고시(제2023-12호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
                  </li>
                  <li>
                    ④ 개인정보 열람 및 처리정지 요구는 
                    「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다. 
                  </li>
                  <li>
                    ⑤ 개인정보의 정정 및 삭제 요구는 
                    다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다. 
                  </li>
                  <li>
                    ⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 
                    요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">8. 개인정보의 안정성 확보 조치</h4>
                <ul class="agree_in">
                  <li>
                    ① 회사는 이용자의 개인정보를 처리함에 있어 개인정보가 
                    분실, 도난, 누출, 변조 또는 훼손되지 않도록 안정성 확보를 위해 
                    아래와 같은 조치를 취하고 있습니다.
                  </li>
                  <li>
                    가. 관리적 조치<br />
                    1) ‘개인정보의 안전성 확보조치 기준'에 따라 내부관리계획을 수립 및 시행합니다.<br />
                    2) 개인정보취급자의 지정을 최소화하고 개인정보보호 교육을 시행하고 있습니다.
                  </li>
                  <li>
                    나. 기술적 조치<br />
                    1) 침입차단시스템과 탐지시스템을 이용하여 외부로부터의 무단접근을 통제하고 있습니다. 
                    또한 개인정보처리시스템에 대한 접근권한 관리를 통하여 개인정보에 대한 접근을 통제하며, 
                    권한 부여, 변경 또는 말소에 대한 내역을 기록하고, 그 기록을 최소 3년간 보관하고 있습니다.<br />
                    2) 이용자의 개인정보를 암호화된 통신구간(SSL)을 이용하여 전송하고, 비밀번호 등 
                    중요정보는 안전한 암호화 알고리즘으로 암호화되어 저장/관리되고 있습니다.<br />
                    3) 개인정보처리시스템에 접속한 기록을 최소 2년 이상 보관, 관리하고 있으며, 
                    접속 기록이 위변조 및 도난, 분실되지 않도록 관리하고 있습니다.<br />
                    4) 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위해 
                    보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 
                    기술적, 물리적으로 감시 및 차단하고 있습니다.
                  </li>
                  <li>
                    다.물리적 조치<br />
                    1) 개인정보를 보관하고 있는 개인정보처리시스템의 물리적 보관 장소를 별도로 두고 
                    이에 대해 출입통제 절차를 수립, 운영하고 있습니다.<br />
                    2) 개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.
                  </li>
                  <li>
                    ② 이용자의 부주의나 회사가 관리하지 않는 영역에서의 사고 등 
                    회사의 귀책에 기인하지 않은 손해에 대해서 회사는 책임을 지지 않습니다.<br />
                    ③ 이용자의 아이디와 비밀번호는 반드시 본인만 사용하시고, 
                    영문자, 숫자, 특수문자를 조합하여 타인이 유추하기 어려운 비밀번호를 사용하는 것이 좋습니다.<br />
                    ④ 서비스의 이용을 마친 후에는 항상 로그아웃 하여 웹 브라우저를 종료하는 것이 좋습니다. 
                    특히, 다른 사람과 컴퓨터를 공유하거나, 공공장소에서 이용하는 경우에 개인정보보호를 위해서는 
                    이와 같은 절차가 더욱 필요합니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항
                </h4>
                <ul class="agree_in">
                  <li>
                    회사는 이용자의 정보를 수시로 저장하고 찾아내는
                    '쿠키(cookie)'를 개인정보를 자동으로 수집하는 장치로 설치.
                    운용합니다. <br />
                    쿠키란 웹사이트를 운영하는데 이용되는
                    서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서
                    고객의 컴퓨터 하드디스크에 저장됩니다.
                  </li>
                  <li>
                    회사는 아래와 같은 목적을 위해 쿠키 등을
                    사용합니다.
                  </li>
                  <li>
                    ▶ 쿠키 등 사용 목적<br />
                    - 이용자를 인식하여 화면 이동시 사용의 편리성 제공 및
                    이용자에게 최적화된 정보 제공<br />
                    귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서,
                    고객은 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를
                    허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면
                    모든 쿠키의 저장을 거부할 수도 있습니다.
                  </li>
                  <li>
                    ▶ 쿠키 설정 거부 방법<br />
                    이용자는 웹 브라우저의 옵션을 설정함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 
                    모든 쿠키의 저장을 거부할 수 있습니다.
                    단, 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.<br />
                  </li>
                  <li>
                    - 설정방법<br />
                    1) Internet Explorer의 경우: 웹 브라우저 상단의 도구 메뉴 > 인터넷 옵션 > 개인정보 > 설정<br />
                    2) Chrome의 경우: 웹 브라우저 우측의 설정 메뉴 > 화면 하단의 설정 표시 > 개인정보 보호 및 보안 > 서드 파티 쿠키<br />
                    3) 마이크로소프트 엣지의 경우 :  웹 브라우저 상단의 [ ··· ] 클릭 > 설정 > 쿠키 및 사이트 권한 > 쿠키 및 사이트 데이터 관리 및 삭제 > 쿠키 차단여부 선택<br />
                    4) 모바일 사파리의 경우 : 설정 > 사파리 > 쿠키 차단여부 선택
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  10. 개인정보 보호책임자에 관한 사항
                </h4>
                <ul class="agree_in">
                  <li>
                    회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 
                    개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 
                    아래와 같이 개인정보 보호책임자를 지정하고 있습니다. 
                  </li>
                  <li>
                    가. 개인정보 보호책임자<br />
                    - 성명 : 곽상훈<br />
                    - 소속 : 스마트빌사업본부 솔루션서비스팀<br />
                  </li>
                  <li>
                    나. 개인정보 보호담당자<br />
                    - 성명 : 이상혁<br />
                    - 소속 : 연구소<br />
                    - E-mail : privacy@businesson.co.kr<br />
                  </li>
                  <li>
                    다. 개인정보 관련 고충처리<br />
                    - 고객서비스팀<br />
                    - 전화번호 : 1588-8064<br />
                    - 팩스번호 : 02-559-0808<br />
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">11. 개인정보의 열람청구를 접수·처리하는 부서</h4>
                <ul class="agree_in">
                  <li>
                    회사는 개인정보의 열람청구와 관련하여 원활한 의사소통을 위해 아래의 부서를 운영하고 있습니다. 
                  </li>
                  <li>
                    가. 개인정보 열람청구 접수·처리 부서 <br />
                    - 고객서비스팀<br />
                    - 전화번호 : 1588-8064<br />
                    - 팩스번호 : 02-559-0808<br />
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">12. 정보주체의 권익침해에 대한 구제방법</h4>
                <ul class="agree_in">
                  <li>
                    개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 
                    분쟁해결이나 상담 등을 신청할 수 있습니다. 
                  </li>
                  <li>
                    - 개인정보분쟁조정위원회 : (국번없이 1833-6972 / www.kopico.go.kr) <br />
                    - 개인정보침해신고센터 : (국번없이 118 / privacy.kisa.or.kr)<br />
                    - 대검찰청 : (국번없이 1301 / www.spo.go.kr)<br />
                    - 경찰청 : (국번없이 182 / ecrm.cyber.go.kr)<br />
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">13. 개인정보 처리방침의 변경에 관한 사항</h4>
                <ul class="agree_in">
                  <li>
                    개인정보처리방침은 내용 추가, 삭제 및 수정이 있을 시에는 홈페이지의 '공지사항'을 통해 고지합니다.
                  </li>
                  <li>시행일자 : 2024년 04월 15일</li>
                </ul>
              </li>
            </ul>
          </v-col>
          <!--/시행중인 개인정보취급방침 보기-->
          <!--[2020년 12월 14일] 이전-->
          <v-col cols="12" class="protPage" v-if="step1 === true">
            <div class="prot_box">
              <ul class="agree_list">
                <li>
                  SmartEContract는 개인정보보호법 및 정보통신망 이용촉진 및
                  정보보호 등에 관한 법률에 따라 정보주체의 개인정보를 보호하고
                  관련된 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을
                  두고 있습니다.
                </li>
                <li>
                  개인정보취급방침은 정부의 법률 및 지침의 변경과
                  SmartEContract의 정책 변화에 따라 변경될 수 있고, 이에 따라
                  개인정보취급방침을 개정하는 경우 공지사항을 통하여 미리
                  공지하여 고객이 확인할 수 있도록 조치하고 있습니다.
                </li>
                <li>
                  SmartEContract는 개인정보취급방침을 통하여 고객들이 제공하는
                  개인정보가 어떠한 용도와 방식으로 이용되고 있으며
                  개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드리고자
                  합니다.
                </li>
              </ul>
            </div>
            <h3 class="agree_h1">
              SmartEContract 개인정보취급방침은 다음과 같은 내용을 담고
              있습니다.
            </h3>
            <ul class="agree_list">
              <li>
                <ul class="agree_in">
                  <li>1. 수집하는 개인정보의 항목 및 수집방법</li>
                  <li>2. 개인정보의 수집 및 이용목적</li>
                  <li>3. 개인정보의 보유 및 이용기간</li>
                  <li>4. 개인정보 파기절차 및 방법</li>
                  <li>5. 개인정보 공유 및 제공</li>
                  <li>6. 수집한 개인정보 취급위탁업무 내용 및 수탁자</li>
                  <li>7. 이용자 및 법정대리인의 권리와 그 행사방법</li>
                  <li>
                    8. 개인정보 자동수집 장치의 설치,운영 및 그 거부에 관한 사항
                  </li>
                  <li>9. 개인정보의 기술적/관리적 보호 대책</li>
                  <li>
                    10. 개인정보관리책임자 및 담당자의 소속-성명 및 연락처
                  </li>
                  <li>11. 고지의 의무</li>
                </ul>
              </li>
            </ul>
            <ul class="agree_list">
              <li>
                <h4 class="agree_h2">
                  1. 수집하는 개인정보의 항목 및 수집방법
                </h4>
                <ul class="agree_in">
                  <li>
                    개인정보란 생존하는 개인에 관한 정보로서 당해 개인을 식별할
                    수 있는 정보 (당해 정보만으로는 특정 개인을 식별할 수
                    없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을
                    포함합니다.)를 말합니다.
                  </li>
                  <li>
                    <span class="prot_txtb">가. 수집하는 개인정보의 항목</span
                    ><br />
                    <ul class="pt_mgl">
                      <li>
                        1. SmartEContract는 회원가입, 원활한 고객상담, 각종
                        서비스의 제공을 위해 최초 회원가입 당시 아래와 같은
                        최소한의 개인정보를 필수항목으로 수집하고 있습니다.<br />
                        - 수집항목 : 아이디, 성명, 비밀번호, 이메일, 연락처
                      </li>
                      <li>
                        2. 서비스 이용과정에서 아래와 같은 정보들이 자동으로
                        생성되어 수집될 수 있습니다.<br />
                        - IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량
                        이용 기록
                      </li>
                      <li>
                        3. 유료서비스를 이용하는 경우에는 대금결제를 위하여
                        다음과 같은 추가정보를 수집합니다.<br />
                        - 계좌이체시 : 은행명, 계좌번호, 계좌비밀번호,
                        생년월일/사업자번호, 이메일, 연락처 등<br />
                        - 무통장입금시 : 예금주명, 생년월일/사업자번호, 이메일,
                        연락처 등<br />
                        - 자동이체 신청시 : 은행명, 계좌번호, 예금주명,
                        생년월일/사업자번호 등
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span class="prot_txtb">나. 개인정보 수집방법</span><br />
                    <ul class="pt_mgl">
                      <li>
                        SmartEContract는 다음과 같은 방법으로 개인정보를
                        수집합니다.<br />
                        - 홈페이지 회원가입, 기업관리자의 오프라인을 통한
                        대량회원가입 요청양식 작성을 통한 수집, 서비스 이용을
                        통한 수집, 문의 게시판, 팩스, 전화, 이메일 고객센터
                        문의하기
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">2. 개인정보의 수집 및 이용목적</h4>
                <ul class="agree_in">
                  <li>
                    SmartEContract는 회원가입 시 서비스 이용을 위한 최소한의
                    정보만을 수집합니다. <br />수집하는 개인정보 항목에 따른
                    구체적인 수집목적 및 이용목적은 다음과 같습니다.
                  </li>
                  <li>
                    <span class="prot_txtb"
                      >1. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른
                      요금정산</span
                    ><br />전자계약 서비스 이용시 필요한 정보전달 및 요금결제,
                    청구서 발송
                  </li>
                  <li>
                    <span class="prot_txtb">2. 회원 관리</span><br />회원제
                    서비스 이용 및 제한적 본인 확인제에 따른 본인확인, 개인
                    식별, 신용평가기관을 통한 실명확인, 연령제한 서비스의 제공,
                    부정이용방지와 비인가 사용 방지, 가입 의사 확인, 불만처리 등
                    민원처리, 고지사항 전달
                  </li>
                  <li>
                    <span class="prot_txtb">3. 마케팅 및 광고 활용</span
                    ><br />마케팅 및 광고 활용, 회원의 서비스 이용에 대한 통계,
                    통계학적 분석(회원의 업종별, 기업규모별, 지역별 통계분석 등)
                  </li>
                  <li>
                    가입하신 정보는 해당서비스 제공이나 고객께 사전에 밝힌 목적
                    이외의 다른 어떠한 목적으로도 사용되지 않음을 알려드립니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">3. 개인정보의 보유 및 이용기간</h4>
                <ul class="agree_in">
                  <li>
                    SmartEContract 회원가입일로부터 SmartEContract고객으로서
                    SmartEContract에서 제공하는 서비스를 이용하는 동안
                    SmartEContract는 개인정보를 보유하며 서비스제공 등을 위해
                    이용합니다. 단, 고객 본인이 직접 삭제하거나 수정한 정보,
                    고객탈퇴를 요청한 경우에는 고객의 개인정보를 재생이 불가능한
                    방법으로 즉시 파기합니다. <br />아이디 항목은 중복 아이디가
                    존재할 위험이 있어 타 개인정보와 분리하여 보관합니다. <br />
                    다만 다음 각 호의 경우에는 각 호에 명시한 기간 동안
                    개인정보를 보유합니다. <br />
                    <ul class="ag_mgl">
                      <li>
                        ① 본인확인에 관한 기록 <br />
                        - 보존 근거 : 정보통신망 이용촉진 및 정보보호 등에 관한
                        법률 <br />
                        - 보존 기간 : 6개월
                      </li>
                      <li>
                        ② 계약 또는 청약철회 등에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 5년
                      </li>
                      <li>
                        ③ 대금결제 및 재화 등의 공급에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 5년
                      </li>
                      <li>
                        ④ 소비자의 불만 또는 분쟁처리에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 3년<br />
                      </li>
                      <li>
                        ⑤ 보유기간을 고객에게 미리 고지하고 그 보유기간이
                        경과하지 아니한 경우와 개별적으로 고객의 동의를 받을
                        경우에는 약속한 기간 동안 보유
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">4. 개인정보 파기절차 및 방법</h4>
                <ul class="agree_in">
                  <li>
                    SmartEContract 고객의 개인정보는 원칙적으로 개인정보의 수집
                    및 이용목적이 달성되면 지체 없이 파기합니다. 파기절차 및
                    방법은 다음과 같습니다.
                  </li>
                  <li>
                    <span class="prot_txtb">가. 파기절차</span><br />
                    <ul class="pt_mgl">
                      <li>
                        회원가입 등을 통한 개입정보의 수집, 이용, 제공 등 고객이
                        동의한 내용에 대해 고객은 언제든지 철회할 수 있으며,
                        동의철회는 로그인 후 [정보관리하기] &gt; [회원탈퇴]
                        메뉴를 통해서 할 수 있습니다. <br />
                        SmartEContract는 탈퇴를 요청하는 회원의 탈퇴처리 후
                        개인정보를 삭제합니다. <br />
                        개인정보 담당자에게 전화, 서면, 이메일 등으로 연락하시면
                        신속하게 개인정보 삭제 등 필요한 조치를 합니다.
                      </li>
                      <li>
                        단, '3. 개인정보의 보유 및 이용기간' 에서 명시한 기간
                        동안 개인정보를 보관 후 파기하며, 해당 정보는 법률에
                        의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
                      </li>
                      <li>
                        고객이 SmartEContract 서비스의 요금이 정상적으로
                        납입되지 않은 경우에는 회원 탈퇴가 가능하지 않습니다.
                        <br />이 경우 고객센터로 연락하여 탈퇴에 필요한 절차를
                        밟으신 후, 탈퇴를 할 수 있습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span class="prot_txtb">나. 파기방법</span><br />
                    <ul class="pt_mgl">
                      <li>
                        - 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수
                        없는 기술적 방법을 사용하여 삭제합니다.
                      </li>
                      <li>
                        - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을
                        통하여 파기합니다.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">5. 개인정보 공유 및 제공</h4>
                <ul class="agree_in">
                  <li>
                    회사는 고객의 개인정보를 ‘2. 개인 정보의 수집목적 및
                    이용목적’에서 고지한 범위 내에서 개인정보를 이용하며, 동
                    범위를 초과하여 이용하거나 SmartEContract 사이트 외부에
                    제공하지 않습니다.
                  </li>
                  <li>
                    다만, 다음의 경우에는 예외적으로 회원의 동의 없이 개인정보를
                    제공할 수 있습니다.<br />
                    <ul class="ag_mgl">
                      <li>
                        - 법령의 규정에 의거하거나, 수사상 목적으로 법령에
                        정해진 절차와 방법에 따라 관련기관의 요구가 있는 경우
                      </li>
                      <li>- 고객이 사전에 동의한 경우</li>
                      <li>
                        - 유료 서비스 제공에 따른 요금 결제를 위하여 필요한 경우
                      </li>
                      <li>- 신용평가기관을 통한 본인확인에 필요한 경</li>
                      <li>
                        - 통계처리, 학술연구, 시장조사 등을 위하여 필요한
                        경우에는 특정한 개인을 식별할 수 없는 형태로 가공하여
                        제공하는 경우
                      </li>
                      <li>
                        - 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  6. 수집한 개인정보 취급위탁업무 내용 및 수탁자
                </h4>
                <ul class="agree_in">
                  <li>
                    회사는 서비스 향상을 위하여 고객의 개인정보를 외부
                    전문기관에 처리 위탁할 수 있습니다. 회사는 개인정보를 처리
                    위탁하는 경우 서면, 전자우편, 전화 또는 홈페이지를 통해
                    고객에게 사전에 고지하며, 위탁계약 등을 통하여
                    서비스제공자의 개인정보보호 관련 지시엄수, 개인정보에 관한
                    비밀유지, 제3자 제공의 금지 및 사고시의 책임부담, 위탁기간,
                    처리 종료후의 개인정보의 반환 또는 파기 등을 명확히 규정하고
                    당해 계약 내용을 서면 또는 전자적으로 보관하여 고객의 권익을
                    보호합니다.
                  </li>
                  <li>
                    회사는 회원에 대하여 보다 더 질 높은 서비스 제공 등을 위해
                    아래와 같이 귀하의 개인정보를 제공하고 있습니다.
                  </li>
                  <li>
                    <table class="term_tbl">
                      <colgroup>
                        <col style="width:24%" />
                        <col style="width:38%" />
                        <col style="width:38%" />
                      </colgroup>
                      <tr>
                        <th scope="col">수탁업체</th>
                        <th scope="col">위탁업무 내용</th>
                        <th scope="col">위탁처리 정보</th>
                      </tr>
                      <tr>
                        <td>시스원</td>
                        <td>인프라 관리</td>
                        <td>별도 정보 제공 없음</td>
                      </tr>
                    </table>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  7. 이용자 및 법정대리인의 권리와 그 행사방법
                </h4>
                <ul class="agree_in">
                  <li>
                    SmartEContract 이용 고객 및 법정대리인은 언제든지 등록되어
                    있는 본인 혹은 대리하는 자의 개인정보를 열람하거나 정정할 수
                    있으며 동의철회를 요청할 수도 있습니다. 다만, 그러한 경우
                    서비스의 일부 또는 전부 이용이 어려울 수 있습니다.
                  </li>
                  <li>
                    SmartEContract 고객 본인 혹은 대리하는 자의 개인정보 열람 및
                    정정을 위해서는 홈페이지에 로그인 후 [정보수정]을 클릭하여
                    직접 조회 또는 수정을, 탈퇴(동의철회)를 위해서는 로그인 후
                    [정보관리하기] > [회원탈퇴] 클릭하여 본인 확인 절차를 거치신
                    후 직접 열람, 정정 또는 탈퇴가 가능합니다.
                  </li>
                  <li>
                    또는 개인정보관리담당자에게 (전화, e-Mail)로 연락하시면
                    본인임을 확인한 후 지체 없이 조치하겠습니다.
                  </li>
                  <li>
                    고객이 개인정보의 오류에 대한 정정을 요청한 경우에는 정정을
                    완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.
                    또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정
                    처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록
                    하겠습니다.
                  </li>
                  <li>
                    SmartEContract 이용자 혹은 법정 대리인의 요청에 의해 해지
                    또는 삭제된 개인정보는 "3. 개인정보의 보유 및 이용기간"에
                    명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수
                    없도록 처리하고 있습니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항
                </h4>
                <ul class="agree_in">
                  <li>
                    SmartEContract 고객의 정보를 수시로 저장하고 찾아내는
                    '쿠키(cookie)'를 개인정보를 자동으로 수집하는 장치로 설치.
                    운용합니다. <br />
                    쿠키란 SmartEContract의 웹사이트를 운영하는데 이용되는
                    서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서
                    고객의 컴퓨터 하드디스크에 저장됩니다.
                  </li>
                  <li>
                    SmartEContract는 다음과 같은 목적을 위해 쿠키 등을
                    사용합니다.
                  </li>
                  <li>
                    ▶ 쿠키 등 사용 목적<br />
                    - 이용자를 인식하여 화면 이동시 사용의 편리성 제공 및
                    이용자에게 최적화된 정보 제공<br />
                    귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서,
                    고객은 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를
                    허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면
                    모든 쿠키의 저장을 거부할 수도 있습니다.
                  </li>
                  <li>
                    ▶ 쿠키 설정 거부 방법<br />
                    쿠키 설정을 거부하는 방법으로는 고객이 사용하는 웹
                    브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를
                    저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수
                    있습니다. <br />
                    설정방법 예(인터넷 익스플로어의 경우) <br />
                    : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 <br />
                    단, 고객께서 쿠키 설치를 거부하였을 경우 서비스 제공에
                    어려움이 있을 수 있습니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">9. 개인정보의 기술적/관리적 보호 대책</h4>
                <ul class="agree_in">
                  <li>
                    SmartEContract는 고객의 개인정보를 취급함에 있어 개인정보가
                    분실, 도난, 누출, 변조 또는 훼손되지 않도록 안정성 확보를
                    위하여 다음과 같은 기술적, 관리적 대책을 강구하고 있습니다.
                  </li>
                  <li>
                    1. 비밀번호 암호화<br />
                    SmartEContract 회원 아이디의 비밀번호는 암호화되어 저장 및
                    관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및
                    변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.
                  </li>
                  <li>
                    2. 해킹 등에 대비한 기술적 대책<br />
                    SmartEContract는 해킹이나 컴퓨터 바이러스 등에 의해 이용자의
                    개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고
                    있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고
                    있고, 최신 백신 프로그램을 이용하여 SmartEContract 고객의
                    개인정보가 침해되는 것을 방지하고 있습니다.
                  </li>
                  <li>
                    3. 취급직원 최소화 및 교육<br />
                    개인정보관련 취급 직원은 담당자에 한정시켜 최소화 하고 이를
                    위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며,
                    접근 권한을 관리하는 새로운 보안기술의 습득 및 개인정보보호
                    의무에 관해 담당자에 대한 수시 교육을 통하여 SmartEContract
                    개인정보취급방침의 준수를 항상 강조하고 있습니다.
                  </li>
                  <li>
                    4. 개인정보보호전담기구의 운영<br />
                    사내 개인정보보호전담기구 등을 통하여 SmartEContract
                    개인정보취급방침의 이행사항 및 담당자의 준수여부를 확인하여
                    문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록
                    노력하고 있습니다.
                  </li>
                  <li>
                    단,SmartEContract는 고객 개인적인 부주의나 인터넷상의 문제로
                    아이디, 비밀번호 블록체인 비밀번호 등 개인정보가 유출되어
                    발생한 문제와 기본적인 인터넷의 위험성 때문에 일어나는
                    일들에 대해 책임을 지지 않습니다. <br />
                    공용PC에서의 로그인시 개인정보가 유출되지 않도록 각별한
                    주의를 기울여 주시기 바랍니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  10. 개인정보 관리책임자 및 담당자의 소속-성명 및 연락처
                </h4>
                <ul class="agree_in">
                  <li>
                    [개인정보 관리책임자]<br />
                    성명 : 한광희<br />
                    소속/직위 : SmartEContract 사업총괄<br />
                    E-mail : kenny.han@businesson.co.kr<br />
                    Tel : 02)559-0801<br />
                    Fax : 02)559-0808
                  </li>
                  <li>
                    [개인정보 관리담당자]<br />
                    성명 : 정인수<br />
                    소속/직위 : 글로싸인엔터프라이즈 서비스운영팀/차장<br />
                    E-mail : jisyr@businesson.co.kr<br />
                    Tel : 02)559-0842<br />
                    Fax : 02)559-0808
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">11. 고지의 의무</h4>
                <ul class="agree_in">
                  <li>
                    현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는
                    개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할
                    것입니다.
                  </li>
                  <li>시행일자 : 2018년 07월 19일</li>
                </ul>
              </li>
            </ul>
          </v-col>
          <!--/[2020년 12월 14일] 이전-->

          <!--[2022년 10월 12일] 이전-->
          <v-col cols="12" class="protPage" v-if="step2 === true">
            <div class="prot_box">
              <ul class="agree_list">
                <li>
                  스마트빌싸인은 개인정보보호법 및 정보통신망 이용촉진 및
                  정보보호 등에 관한 법률에 따라 정보주체의 개인정보를 보호하고
                  관련된 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을
                  두고 있습니다.
                </li>
                <li>
                  개인정보취급방침은 정부의 법률 및 지침의 변경과 스마트빌싸인의
                  정책 변화에 따라 변경될 수 있고, 이에 따라 개인정보취급방침을
                  개정하는 경우 공지사항을 통하여 미리 공지하여 고객이 확인할 수
                  있도록 조치하고 있습니다.
                </li>
                <li>
                  스마트빌싸인은 개인정보취급방침을 통하여 고객들이 제공하는
                  개인정보가 어떠한 용도와 방식으로 이용되고 있으며
                  개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드리고자
                  합니다.
                </li>
              </ul>
            </div>
            <h3 class="agree_h1">
              스마트빌싸인 개인정보취급방침은 다음과 같은 내용을 담고 있습니다.
            </h3>
            <ul class="agree_list">
              <li>
                <ul class="agree_in">
                  <li>1. 수집하는 개인정보의 항목 및 수집방법</li>
                  <li>2. 개인정보의 수집 및 이용목적</li>
                  <li>3. 개인정보의 보유 및 이용기간</li>
                  <li>4. 개인정보 파기절차 및 방법</li>
                  <li>5. 개인정보 공유 및 제공</li>
                  <li>6. 수집한 개인정보 취급위탁업무 내용 및 수탁자</li>
                  <li>7. 이용자 및 법정대리인의 권리와 그 행사방법</li>
                  <li>
                    8. 개인정보 자동수집 장치의 설치,운영 및 그 거부에 관한 사항
                  </li>
                  <li>9. 개인정보의 기술적/관리적 보호 대책</li>
                  <li>
                    10. 개인정보관리책임자 및 담당자의 소속-성명 및 연락처
                  </li>
                  <li>11. 고지의 의무</li>
                </ul>
              </li>
            </ul>
            <ul class="agree_list">
              <li>
                <h4 class="agree_h2">
                  1. 수집하는 개인정보의 항목 및 수집방법
                </h4>
                <ul class="agree_in">
                  <li>
                    개인정보란 생존하는 개인에 관한 정보로서 당해 개인을 식별할
                    수 있는 정보 (당해 정보만으로는 특정 개인을 식별할 수
                    없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을
                    포함합니다.)를 말합니다.
                  </li>
                  <li>
                    <span class="prot_txtb">가. 수집하는 개인정보의 항목</span
                    ><br />
                    <ul class="pt_mgl">
                      <li>
                        1. 스마트빌싸인은 회원가입, 원활한 고객상담, 각종
                        서비스의 제공을 위해 최초 회원가입 당시 아래와 같은
                        최소한의 개인정보를 필수항목으로 수집하고 있습니다.<br />
                        - 수집항목 : 아이디, 성명, 비밀번호, 이메일, 연락처
                      </li>
                      <li>
                        2. 서비스 이용과정에서 아래와 같은 정보들이 자동으로
                        생성되어 수집될 수 있습니다.<br />
                        - IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량
                        이용 기록
                      </li>
                      <li>
                        3. 유료서비스를 이용하는 경우에는 대금결제를 위하여
                        다음과 같은 추가정보를 수집합니다.<br />
                        - 계좌이체시 : 은행명, 계좌번호, 계좌비밀번호,
                        생년월일/사업자번호, 이메일, 연락처 등<br />
                        - 무통장입금시 : 예금주명, 생년월일/사업자번호, 이메일,
                        연락처 등<br />
                        - 자동이체 신청시 : 은행명, 계좌번호, 예금주명,
                        생년월일/사업자번호 등
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span class="prot_txtb">나. 개인정보 수집방법</span><br />
                    <ul class="pt_mgl">
                      <li>
                        스마트빌싸인은 다음과 같은 방법으로 개인정보를
                        수집합니다.<br />
                        - 홈페이지 회원가입, 기업관리자의 오프라인을 통한
                        대량회원가입 요청양식 작성을 통한 수집, 서비스 이용을
                        통한 수집, 문의 게시판, 팩스, 전화, 이메일 고객센터
                        문의하기
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">2. 개인정보의 수집 및 이용목적</h4>
                <ul class="agree_in">
                  <li>
                    스마트빌싸인은 회원가입 시 서비스 이용을 위한 최소한의
                    정보만을 수집합니다. <br />수집하는 개인정보 항목에 따른
                    구체적인 수집목적 및 이용목적은 다음과 같습니다.
                  </li>
                  <li>
                    <span class="prot_txtb"
                      >1. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른
                      요금정산</span
                    ><br />전자계약 서비스 이용시 필요한 정보전달 및 요금결제,
                    청구서 발송
                  </li>
                  <li>
                    <span class="prot_txtb">2. 회원 관리</span><br />회원제
                    서비스 이용 및 제한적 본인 확인제에 따른 본인확인, 개인
                    식별, 신용평가기관을 통한 실명확인, 연령제한 서비스의 제공,
                    부정이용방지와 비인가 사용 방지, 가입 의사 확인, 불만처리 등
                    민원처리, 고지사항 전달
                  </li>
                  <li>
                    <span class="prot_txtb">3. 마케팅 및 광고 활용</span
                    ><br />마케팅 및 광고 활용, 회원의 서비스 이용에 대한 통계,
                    통계학적 분석(회원의 업종별, 기업규모별, 지역별 통계분석 등)
                  </li>
                  <li>
                    가입하신 정보는 해당서비스 제공이나 고객께 사전에 밝힌 목적
                    이외의 다른 어떠한 목적으로도 사용되지 않음을 알려드립니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">3. 개인정보의 보유 및 이용기간</h4>
                <ul class="agree_in">
                  <li>
                    스마트빌싸인 회원가입일로부터 스마트빌싸인고객으로서
                    스마트빌싸인에서 제공하는 서비스를 이용하는 동안
                    스마트빌싸인은 개인정보를 보유하며 서비스제공 등을 위해
                    이용합니다. 단, 고객 본인이 직접 삭제하거나 수정한 정보,
                    고객탈퇴를 요청한 경우에는 고객의 개인정보를 재생이 불가능한
                    방법으로 즉시 파기합니다. <br />아이디 항목은 중복 아이디가
                    존재할 위험이 있어 타 개인정보와 분리하여 보관합니다. <br />
                    다만 다음 각 호의 경우에는 각 호에 명시한 기간 동안
                    개인정보를 보유합니다. <br />
                    <ul class="ag_mgl">
                      <li>
                        ① 본인확인에 관한 기록 <br />
                        - 보존 근거 : 정보통신망 이용촉진 및 정보보호 등에 관한
                        법률 <br />
                        - 보존 기간 : 6개월
                      </li>
                      <li>
                        ② 계약 또는 청약철회 등에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 5년
                      </li>
                      <li>
                        ③ 대금결제 및 재화 등의 공급에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 5년
                      </li>
                      <li>
                        ④ 소비자의 불만 또는 분쟁처리에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 3년<br />
                      </li>
                      <li>
                        ⑤ 보유기간을 고객에게 미리 고지하고 그 보유기간이
                        경과하지 아니한 경우와 개별적으로 고객의 동의를 받을
                        경우에는 약속한 기간 동안 보유
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">4. 개인정보 파기절차 및 방법</h4>
                <ul class="agree_in">
                  <li>
                    스마트빌싸인 고객의 개인정보는 원칙적으로 개인정보의 수집 및
                    이용목적이 달성되면 지체 없이 파기합니다. 파기절차 및 방법은
                    다음과 같습니다.
                  </li>
                  <li>
                    <span class="prot_txtb">가. 파기절차</span><br />
                    <ul class="pt_mgl">
                      <li>
                        회원가입 등을 통한 개입정보의 수집, 이용, 제공 등 고객이
                        동의한 내용에 대해 고객은 언제든지 철회할 수 있으며,
                        동의철회는 로그인 후 [정보관리하기] &gt; [회원탈퇴]
                        메뉴를 통해서 할 수 있습니다. <br />
                        스마트빌싸인은 탈퇴를 요청하는 회원의 탈퇴처리 후
                        개인정보를 삭제합니다. <br />
                        개인정보 담당자에게 전화, 서면, 이메일 등으로 연락하시면
                        신속하게 개인정보 삭제 등 필요한 조치를 합니다.
                      </li>
                      <li>
                        단, '3. 개인정보의 보유 및 이용기간' 에서 명시한 기간
                        동안 개인정보를 보관 후 파기하며, 해당 정보는 법률에
                        의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
                      </li>
                      <li>
                        고객이 스마트빌싸인 서비스의 요금이 정상적으로 납입되지
                        않은 경우에는 회원 탈퇴가 가능하지 않습니다. <br />이
                        경우 고객센터로 연락하여 탈퇴에 필요한 절차를 밟으신 후,
                        탈퇴를 할 수 있습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span class="prot_txtb">나. 파기방법</span><br />
                    <ul class="pt_mgl">
                      <li>
                        - 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수
                        없는 기술적 방법을 사용하여 삭제합니다.
                      </li>
                      <li>
                        - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을
                        통하여 파기합니다.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">5. 개인정보 공유 및 제공</h4>
                <ul class="agree_in">
                  <li>
                    회사는 고객의 개인정보를 ‘2. 개인 정보의 수집목적 및
                    이용목적’에서 고지한 범위 내에서 개인정보를 이용하며, 동
                    범위를 초과하여 이용하거나 스마트빌싸인 사이트 외부에
                    제공하지 않습니다.
                  </li>
                  <li>
                    다만, 다음의 경우에는 예외적으로 회원의 동의 없이 개인정보를
                    제공할 수 있습니다.<br />
                    <ul class="ag_mgl">
                      <li>
                        - 법령의 규정에 의거하거나, 수사상 목적으로 법령에
                        정해진 절차와 방법에 따라 관련기관의 요구가 있는 경우
                      </li>
                      <li>- 고객이 사전에 동의한 경우</li>
                      <li>
                        - 유료 서비스 제공에 따른 요금 결제를 위하여 필요한 경우
                      </li>
                      <li>- 신용평가기관을 통한 본인확인에 필요한 경</li>
                      <li>
                        - 통계처리, 학술연구, 시장조사 등을 위하여 필요한
                        경우에는 특정한 개인을 식별할 수 없는 형태로 가공하여
                        제공하는 경우
                      </li>
                      <li>
                        - 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  6. 수집한 개인정보 취급위탁업무 내용 및 수탁자
                </h4>
                <ul class="agree_in">
                  <li>
                    회사는 서비스 향상을 위하여 고객의 개인정보를 외부
                    전문기관에 처리 위탁할 수 있습니다. 회사는 개인정보를 처리
                    위탁하는 경우 서면, 전자우편, 전화 또는 홈페이지를 통해
                    고객에게 사전에 고지하며, 위탁계약 등을 통하여
                    서비스제공자의 개인정보보호 관련 지시엄수, 개인정보에 관한
                    비밀유지, 제3자 제공의 금지 및 사고시의 책임부담, 위탁기간,
                    처리 종료후의 개인정보의 반환 또는 파기 등을 명확히 규정하고
                    당해 계약 내용을 서면 또는 전자적으로 보관하여 고객의 권익을
                    보호합니다.
                  </li>
                  <li>
                    회사는 회원에 대하여 보다 더 질 높은 서비스 제공 등을 위해
                    아래와 같이 귀하의 개인정보를 제공하고 있습니다.
                  </li>
                  <li>
                    <table class="term_tbl">
                      <colgroup>
                        <col style="width:40%" />
                        <col style="width:60%" />
                      </colgroup>
                      <tr>
                        <th scope="col">수탁업체</th>
                        <th scope="col">위탁업무 내용</th>
                      </tr>
                      <tr>
                        <td>시스원</td>
                        <td>서비스 인프라 유지보수</td>
                      </tr>
                      <tr>
                        <td>토스페이먼츠</td>
                        <td>서비스 비용 결제 대행</td>
                      </tr>
                      <tr>
                        <td>세종텔레콤</td>
                        <td>SMS 메세징 서비스</td>
                      </tr>
                      <tr>
                        <td>비즈톡</td>
                        <td>카카오톡 메세징 서비스</td>
                      </tr>
                      <tr>
                        <td>KCB</td>
                        <td>본인인증 서비스</td>
                      </tr>
                    </table>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  7. 이용자 및 법정대리인의 권리와 그 행사방법
                </h4>
                <ul class="agree_in">
                  <li>
                    스마트빌싸인 이용 고객 및 법정대리인은 언제든지 등록되어
                    있는 본인 혹은 대리하는 자의 개인정보를 열람하거나 정정할 수
                    있으며 동의철회를 요청할 수도 있습니다. 다만, 그러한 경우
                    서비스의 일부 또는 전부 이용이 어려울 수 있습니다.
                  </li>
                  <li>
                    스마트빌싸인 고객 본인 혹은 대리하는 자의 개인정보 열람 및
                    정정을 위해서는 홈페이지에 로그인 후 [정보수정]을 클릭하여
                    직접 조회 또는 수정을, 탈퇴(동의철회)를 위해서는 로그인 후
                    [정보관리하기] > [회원탈퇴] 클릭하여 본인 확인 절차를 거치신
                    후 직접 열람, 정정 또는 탈퇴가 가능합니다.
                  </li>
                  <li>
                    또는 개인정보관리담당자에게 (전화, e-Mail)로 연락하시면
                    본인임을 확인한 후 지체 없이 조치하겠습니다.
                  </li>
                  <li>
                    고객이 개인정보의 오류에 대한 정정을 요청한 경우에는 정정을
                    완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.
                    또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정
                    처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록
                    하겠습니다.
                  </li>
                  <li>
                    스마트빌싸인 이용자 혹은 법정 대리인의 요청에 의해 해지 또는
                    삭제된 개인정보는 "3. 개인정보의 보유 및 이용기간"에 명시된
                    바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록
                    처리하고 있습니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항
                </h4>
                <ul class="agree_in">
                  <li>
                    스마트빌싸인 고객의 정보를 수시로 저장하고 찾아내는
                    '쿠키(cookie)'를 개인정보를 자동으로 수집하는 장치로 설치.
                    운용합니다. <br />
                    쿠키란 스마트빌싸인의 웹사이트를 운영하는데 이용되는 서버가
                    귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 고객의
                    컴퓨터 하드디스크에 저장됩니다.
                  </li>
                  <li>
                    스마트빌싸인은 다음과 같은 목적을 위해 쿠키 등을 사용합니다.
                  </li>
                  <li>
                    ▶ 쿠키 등 사용 목적<br />
                    - 이용자를 인식하여 화면 이동시 사용의 편리성 제공 및
                    이용자에게 최적화된 정보 제공<br />
                    귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서,
                    고객은 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를
                    허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면
                    모든 쿠키의 저장을 거부할 수도 있습니다.
                  </li>
                  <li>
                    ▶ 쿠키 설정 거부 방법<br />
                    쿠키 설정을 거부하는 방법으로는 고객이 사용하는 웹
                    브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를
                    저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수
                    있습니다. <br />
                    설정방법 예(인터넷 익스플로어의 경우) <br />
                    : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 <br />
                    단, 고객께서 쿠키 설치를 거부하였을 경우 서비스 제공에
                    어려움이 있을 수 있습니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">9. 개인정보의 기술적/관리적 보호 대책</h4>
                <ul class="agree_in">
                  <li>
                    스마트빌싸인은 고객의 개인정보를 취급함에 있어 개인정보가
                    분실, 도난, 누출, 변조 또는 훼손되지 않도록 안정성 확보를
                    위하여 다음과 같은 기술적, 관리적 대책을 강구하고 있습니다.
                  </li>
                  <li>
                    1. 비밀번호 암호화<br />
                    스마트빌싸인 회원 아이디의 비밀번호는 암호화되어 저장 및
                    관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및
                    변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.
                  </li>
                  <li>
                    2. 해킹 등에 대비한 기술적 대책<br />
                    스마트빌싸인은 해킹이나 컴퓨터 바이러스 등에 의해 이용자의
                    개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고
                    있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고
                    있고, 최신 백신 프로그램을 이용하여 스마트빌싸인 고객의
                    개인정보가 침해되는 것을 방지하고 있습니다.
                  </li>
                  <li>
                    3. 취급직원 최소화 및 교육<br />
                    개인정보관련 취급 직원은 담당자에 한정시켜 최소화 하고 이를
                    위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며,
                    접근 권한을 관리하는 새로운 보안기술의 습득 및 개인정보보호
                    의무에 관해 담당자에 대한 수시 교육을 통하여 스마트빌싸인
                    개인정보취급방침의 준수를 항상 강조하고 있습니다.
                  </li>
                  <li>
                    4. 개인정보보호전담기구의 운영<br />
                    사내 개인정보보호전담기구 등을 통하여 스마트빌싸인
                    개인정보취급방침의 이행사항 및 담당자의 준수여부를 확인하여
                    문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록
                    노력하고 있습니다.
                  </li>
                  <li>
                    단,스마트빌싸인은 고객 개인적인 부주의나 인터넷상의 문제로
                    아이디, 비밀번호 블록체인 비밀번호 등 개인정보가 유출되어
                    발생한 문제와 기본적인 인터넷의 위험성 때문에 일어나는
                    일들에 대해 책임을 지지 않습니다. <br />
                    공용PC에서의 로그인시 개인정보가 유출되지 않도록 각별한
                    주의를 기울여 주시기 바랍니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  10. 개인정보 관리책임자 및 담당자의 소속-성명 및 연락처
                </h4>
                <ul class="agree_in">
                  <li>
                    [개인정보 관리책임자]<br />
                    성명 : 한광희<br />
                    소속/직위 : 스마트빌싸인 사업총괄<br />
                    E-mail : kenny.han@businesson.co.kr<br />
                    Tel : 02)559-0801<br />
                    Fax : 02)559-0808
                  </li>
                  <li>
                    [개인정보 관리담당자]<br />
                    성명 : 정인수<br />
                    소속/직위 : 글로싸인엔터프라이즈 서비스운영팀/차장<br />
                    E-mail : jisyr@businesson.co.kr<br />
                    Tel : 02)559-0842<br />
                    Fax : 02)559-0808
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">11. 고지의 의무</h4>
                <ul class="agree_in">
                  <li>
                    현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는
                    개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할
                    것입니다.
                  </li>
                  <li>공고일자 : 2020년 12월 7일</li>
                  <li>시행일자 : 2020년 12월 14일</li>
                </ul>
              </li>
            </ul>
          </v-col>
          <!--/[2022년 10월 12일] 이전-->
          <!--[2024년 04월 15일] 이전-->
          <v-col cols="12" class="protPage" v-if="step3 === true">
            <div class="prot_box">
              <ul class="agree_list">
                <li>
                  글로싸인엔터프라이즈는 개인정보보호법 및 정보통신망 이용촉진
                  및 정보보호 등에 관한 법률에 따라 정보주체의 개인정보를
                  보호하고 관련된 고충을 원활하게 처리할 수 있도록 다음과 같은
                  처리방침을 두고 있습니다.
                </li>
                <li>
                  개인정보취급방침은 정부의 법률 및 지침의 변경과
                  글로싸인엔터프라이즈의 정책 변화에 따라 변경될 수 있고, 이에
                  따라 개인정보취급방침을 개정하는 경우 공지사항을 통하여 미리
                  공지하여 고객이 확인할 수 있도록 조치하고 있습니다.
                </li>
                <li>
                  글로싸인엔터프라이즈는 개인정보취급방침을 통하여 고객들이
                  제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며
                  개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드리고자
                  합니다.
                </li>
              </ul>
            </div>
            <h3 class="agree_h1">
              글로싸인엔터프라이즈 개인정보취급방침은 다음과 같은 내용을 담고
              있습니다.
            </h3>
            <ul class="agree_list">
              <li>
                <ul class="agree_in">
                  <li>1. 수집하는 개인정보의 항목 및 수집방법</li>
                  <li>2. 개인정보의 수집 및 이용목적</li>
                  <li>3. 개인정보의 보유 및 이용기간</li>
                  <li>4. 개인정보 파기절차 및 방법</li>
                  <li>5. 개인정보 공유 및 제공</li>
                  <li>6. 수집한 개인정보 취급위탁업무 내용 및 수탁자</li>
                  <li>7. 이용자 및 법정대리인의 권리와 그 행사방법</li>
                  <li>
                    8. 개인정보 자동수집 장치의 설치,운영 및 그 거부에 관한 사항
                  </li>
                  <li>9. 개인정보의 기술적/관리적 보호 대책</li>
                  <li>
                    10. 개인정보관리책임자 및 담당자의 소속-성명 및 연락처
                  </li>
                  <li>11. 고지의 의무</li>
                </ul>
              </li>
            </ul>
            <ul class="agree_list">
              <li>
                <h4 class="agree_h2">
                  1. 수집하는 개인정보의 항목 및 수집방법
                </h4>
                <ul class="agree_in">
                  <li>
                    개인정보란 생존하는 개인에 관한 정보로서 당해 개인을 식별할
                    수 있는 정보 (당해 정보만으로는 특정 개인을 식별할 수
                    없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을
                    포함합니다.)를 말합니다.
                  </li>
                  <li>
                    <span class="prot_txtb">가. 수집하는 개인정보의 항목</span
                    ><br />
                    <ul class="pt_mgl">
                      <li>
                        1. 글로싸인엔터프라이즈는 회원가입, 원활한 고객상담,
                        각종 서비스의 제공을 위해 최초 회원가입 당시 아래와 같은
                        최소한의 개인정보를 필수항목으로 수집하고 있습니다.<br />
                        - 수집항목 : 아이디, 성명, 비밀번호, 이메일, 연락처
                      </li>
                      <li>
                        2. 서비스 이용과정에서 아래와 같은 정보들이 자동으로
                        생성되어 수집될 수 있습니다.<br />
                        - IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량
                        이용 기록
                      </li>
                      <li>
                        3. 유료서비스를 이용하는 경우에는 대금결제를 위하여
                        다음과 같은 추가정보를 수집합니다.<br />
                        - 계좌이체시 : 은행명, 계좌번호, 계좌비밀번호,
                        생년월일/사업자번호, 이메일, 연락처 등<br />
                        - 무통장입금시 : 예금주명, 생년월일/사업자번호, 이메일,
                        연락처 등<br />
                        - 자동이체 신청시 : 은행명, 계좌번호, 예금주명,
                        생년월일/사업자번호 등
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span class="prot_txtb">나. 개인정보 수집방법</span><br />
                    <ul class="pt_mgl">
                      <li>
                        글로싸인엔터프라이즈는 다음과 같은 방법으로 개인정보를
                        수집합니다.<br />
                        - 홈페이지 회원가입, 기업관리자의 오프라인을 통한
                        대량회원가입 요청양식 작성을 통한 수집, 서비스 이용을
                        통한 수집, 문의 게시판, 팩스, 전화, 이메일 고객센터
                        문의하기
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">2. 개인정보의 수집 및 이용목적</h4>
                <ul class="agree_in">
                  <li>
                    글로싸인엔터프라이즈는 회원가입 시 서비스 이용을 위한
                    최소한의 정보만을 수집합니다. <br />수집하는 개인정보 항목에
                    따른 구체적인 수집목적 및 이용목적은 다음과 같습니다.
                  </li>
                  <li>
                    <span class="prot_txtb"
                      >1. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른
                      요금정산</span
                    ><br />전자계약 서비스 이용시 필요한 정보전달 및 요금결제,
                    청구서 발송
                  </li>
                  <li>
                    <span class="prot_txtb">2. 회원 관리</span><br />회원제
                    서비스 이용 및 제한적 본인 확인제에 따른 본인확인, 개인
                    식별, 신용평가기관을 통한 실명확인, 연령제한 서비스의 제공,
                    부정이용방지와 비인가 사용 방지, 가입 의사 확인, 불만처리 등
                    민원처리, 고지사항 전달
                  </li>
                  <li>
                    <span class="prot_txtb">3. 마케팅 및 광고 활용</span
                    ><br />마케팅 및 광고 활용, 회원의 서비스 이용에 대한 통계,
                    통계학적 분석(회원의 업종별, 기업규모별, 지역별 통계분석 등)
                  </li>
                  <li>
                    가입하신 정보는 해당서비스 제공이나 고객께 사전에 밝힌 목적
                    이외의 다른 어떠한 목적으로도 사용되지 않음을 알려드립니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">3. 개인정보의 보유 및 이용기간</h4>
                <ul class="agree_in">
                  <li>
                    글로싸인엔터프라이즈 회원가입일로부터 글로싸인엔터프라이즈
                    고객으로서 글로싸인엔터프라이즈에서 제공하는 서비스를
                    이용하는 동안 글로싸인엔터프라이즈는 개인정보를 보유하며
                    서비스제공 등을 위해 이용합니다. 단, 고객 본인이 직접
                    삭제하거나 수정한 정보, 고객탈퇴를 요청한 경우에는 고객의
                    개인정보를 재생이 불가능한 방법으로 즉시 파기합니다.
                    <br />아이디 항목은 중복 아이디가 존재할 위험이 있어 타
                    개인정보와 분리하여 보관합니다. <br />
                    다만 다음 각 호의 경우에는 각 호에 명시한 기간 동안
                    개인정보를 보유합니다. <br />
                    <ul class="ag_mgl">
                      <li>
                        ① 본인확인에 관한 기록 <br />
                        - 보존 근거 : 정보통신망 이용촉진 및 정보보호 등에 관한
                        법률 <br />
                        - 보존 기간 : 6개월
                      </li>
                      <li>
                        ② 계약 또는 청약철회 등에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 5년
                      </li>
                      <li>
                        ③ 대금결제 및 재화 등의 공급에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 5년
                      </li>
                      <li>
                        ④ 소비자의 불만 또는 분쟁처리에 관한 기록 <br />
                        - 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률
                        <br />
                        - 보존 기간 : 3년<br />
                      </li>
                      <li>
                        ⑤ 보유기간을 고객에게 미리 고지하고 그 보유기간이
                        경과하지 아니한 경우와 개별적으로 고객의 동의를 받을
                        경우에는 약속한 기간 동안 보유
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">4. 개인정보 파기절차 및 방법</h4>
                <ul class="agree_in">
                  <li>
                    글로싸인엔터프라이즈 고객의 개인정보는 원칙적으로 개인정보의
                    수집 및 이용목적이 달성되면 지체 없이 파기합니다. 파기절차
                    및 방법은 다음과 같습니다.
                  </li>
                  <li>
                    <span class="prot_txtb">가. 파기절차</span><br />
                    <ul class="pt_mgl">
                      <li>
                        회원가입 등을 통한 개입정보의 수집, 이용, 제공 등 고객이
                        동의한 내용에 대해 고객은 언제든지 철회할 수 있으며,
                        동의철회는 로그인 후 [정보관리하기] &gt; [회원탈퇴]
                        메뉴를 통해서 할 수 있습니다. <br />
                        글로싸인엔터프라이즈는 탈퇴를 요청하는 회원의 탈퇴처리
                        후 개인정보를 삭제합니다. <br />
                        개인정보 담당자에게 전화, 서면, 이메일 등으로 연락하시면
                        신속하게 개인정보 삭제 등 필요한 조치를 합니다.
                      </li>
                      <li>
                        단, '3. 개인정보의 보유 및 이용기간' 에서 명시한 기간
                        동안 개인정보를 보관 후 파기하며, 해당 정보는 법률에
                        의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
                      </li>
                      <li>
                        고객이 글로싸인엔터프라이즈 서비스의 요금이 정상적으로
                        납입되지 않은 경우에는 회원 탈퇴가 가능하지 않습니다.
                        <br />이 경우 고객센터로 연락하여 탈퇴에 필요한 절차를
                        밟으신 후, 탈퇴를 할 수 있습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span class="prot_txtb">나. 파기방법</span><br />
                    <ul class="pt_mgl">
                      <li>
                        - 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수
                        없는 기술적 방법을 사용하여 삭제합니다.
                      </li>
                      <li>
                        - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을
                        통하여 파기합니다.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">5. 개인정보 공유 및 제공</h4>
                <ul class="agree_in">
                  <li>
                    회사는 고객의 개인정보를 ‘2. 개인 정보의 수집목적 및
                    이용목적’에서 고지한 범위 내에서 개인정보를 이용하며, 동
                    범위를 초과하여 이용하거나 글로싸인엔터프라이즈 사이트
                    외부에 제공하지 않습니다.
                  </li>
                  <li>
                    다만, 다음의 경우에는 예외적으로 회원의 동의 없이 개인정보를
                    제공할 수 있습니다.<br />
                    <ul class="ag_mgl">
                      <li>
                        - 법령의 규정에 의거하거나, 수사상 목적으로 법령에
                        정해진 절차와 방법에 따라 관련기관의 요구가 있는 경우
                      </li>
                      <li>- 고객이 사전에 동의한 경우</li>
                      <li>
                        - 유료 서비스 제공에 따른 요금 결제를 위하여 필요한 경우
                      </li>
                      <li>- 신용평가기관을 통한 본인확인에 필요한 경</li>
                      <li>
                        - 통계처리, 학술연구, 시장조사 등을 위하여 필요한
                        경우에는 특정한 개인을 식별할 수 없는 형태로 가공하여
                        제공하는 경우
                      </li>
                      <li>
                        - 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  6. 수집한 개인정보 취급위탁업무 내용 및 수탁자
                </h4>
                <ul class="agree_in">
                  <li>
                    회사는 서비스 향상을 위하여 고객의 개인정보를 외부
                    전문기관에 처리 위탁할 수 있습니다. 회사는 개인정보를 처리
                    위탁하는 경우 서면, 전자우편, 전화 또는 홈페이지를 통해
                    고객에게 사전에 고지하며, 위탁계약 등을 통하여
                    서비스제공자의 개인정보보호 관련 지시엄수, 개인정보에 관한
                    비밀유지, 제3자 제공의 금지 및 사고시의 책임부담, 위탁기간,
                    처리 종료후의 개인정보의 반환 또는 파기 등을 명확히 규정하고
                    당해 계약 내용을 서면 또는 전자적으로 보관하여 고객의 권익을
                    보호합니다.
                  </li>
                  <li>
                    회사는 회원에 대하여 보다 더 질 높은 서비스 제공 등을 위해
                    아래와 같이 귀하의 개인정보를 제공하고 있습니다.
                  </li>
                  <li>
                    <table class="term_tbl">
                      <colgroup>
                        <col style="width:40%" />
                        <col style="width:60%" />
                      </colgroup>
                      <tr>
                        <th scope="col">수탁업체</th>
                        <th scope="col">위탁업무 내용</th>
                      </tr>
                      <tr>
                        <td>시스원</td>
                        <td>서비스 인프라 유지보수</td>
                      </tr>
                      <tr>
                        <td>토스페이먼츠</td>
                        <td>서비스 비용 결제 대행</td>
                      </tr>
                      <tr>
                        <td>세종텔레콤</td>
                        <td>SMS 메세징 서비스</td>
                      </tr>
                      <tr>
                        <td>비즈톡</td>
                        <td>카카오톡 메세징 서비스</td>
                      </tr>
                      <tr>
                        <td>KCB</td>
                        <td>본인인증 서비스</td>
                      </tr>
                    </table>
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  7. 이용자 및 법정대리인의 권리와 그 행사방법
                </h4>
                <ul class="agree_in">
                  <li>
                    글로싸인엔터프라이즈 이용 고객 및 법정대리인은 언제든지
                    등록되어 있는 본인 혹은 대리하는 자의 개인정보를 열람하거나
                    정정할 수 있으며 동의철회를 요청할 수도 있습니다. 다만,
                    그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수
                    있습니다.
                  </li>
                  <li>
                    글로싸인엔터프라이즈 고객 본인 혹은 대리하는 자의 개인정보
                    열람 및 정정을 위해서는 홈페이지에 로그인 후 [정보수정]을
                    클릭하여 직접 조회 또는 수정을, 탈퇴(동의철회)를 위해서는
                    로그인 후 [정보관리하기] > [회원탈퇴] 클릭하여 본인 확인
                    절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.
                  </li>
                  <li>
                    또는 개인정보관리담당자에게 (전화, e-Mail)로 연락하시면
                    본인임을 확인한 후 지체 없이 조치하겠습니다.
                  </li>
                  <li>
                    고객이 개인정보의 오류에 대한 정정을 요청한 경우에는 정정을
                    완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.
                    또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정
                    처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록
                    하겠습니다.
                  </li>
                  <li>
                    글로싸인엔터프라이즈 이용자 혹은 법정 대리인의 요청에 의해
                    해지 또는 삭제된 개인정보는 "3. 개인정보의 보유 및
                    이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람
                    또는 이용할 수 없도록 처리하고 있습니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항
                </h4>
                <ul class="agree_in">
                  <li>
                    글로싸인엔터프라이즈 고객의 정보를 수시로 저장하고 찾아내는
                    '쿠키(cookie)'를 개인정보를 자동으로 수집하는 장치로 설치.
                    운용합니다. <br />
                    쿠키란 글로싸인엔터프라이즈의 웹사이트를 운영하는데 이용되는
                    서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서
                    고객의 컴퓨터 하드디스크에 저장됩니다.
                  </li>
                  <li>
                    글로싸인엔터프라이즈는 다음과 같은 목적을 위해 쿠키 등을
                    사용합니다.
                  </li>
                  <li>
                    ▶ 쿠키 등 사용 목적<br />
                    - 이용자를 인식하여 화면 이동시 사용의 편리성 제공 및
                    이용자에게 최적화된 정보 제공<br />
                    귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서,
                    고객은 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를
                    허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면
                    모든 쿠키의 저장을 거부할 수도 있습니다.
                  </li>
                  <li>
                    ▶ 쿠키 설정 거부 방법<br />
                    쿠키 설정을 거부하는 방법으로는 고객이 사용하는 웹
                    브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를
                    저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수
                    있습니다. <br />
                    설정방법 예(인터넷 익스플로어의 경우) <br />
                    : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 <br />
                    단, 고객께서 쿠키 설치를 거부하였을 경우 서비스 제공에
                    어려움이 있을 수 있습니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">9. 개인정보의 기술적/관리적 보호 대책</h4>
                <ul class="agree_in">
                  <li>
                    글로싸인엔터프라이즈는 고객의 개인정보를 취급함에 있어
                    개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록
                    안정성 확보를 위하여 다음과 같은 기술적, 관리적 대책을
                    강구하고 있습니다.
                  </li>
                  <li>
                    1. 비밀번호 암호화<br />
                    글로싸인엔터프라이즈 회원 아이디의 비밀번호는 암호화되어
                    저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인
                    및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.
                  </li>
                  <li>
                    2. 해킹 등에 대비한 기술적 대책<br />
                    글로싸인엔터프라이즈는 해킹이나 컴퓨터 바이러스 등에 의해
                    이용자의 개인정보가 유출되거나 훼손되는 것을 막기 위해
                    최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를
                    수시로 백업하고 있고, 최신 백신 프로그램을 이용하여
                    글로싸인엔터프라이즈 고객의 개인정보가 침해되는 것을
                    방지하고 있습니다.
                  </li>
                  <li>
                    3. 취급직원 최소화 및 교육<br />
                    개인정보관련 취급 직원은 담당자에 한정시켜 최소화 하고 이를
                    위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며,
                    접근 권한을 관리하는 새로운 보안기술의 습득 및 개인정보보호
                    의무에 관해 담당자에 대한 수시 교육을 통하여
                    글로싸인엔터프라이즈 개인정보취급방침의 준수를 항상 강조하고
                    있습니다.
                  </li>
                  <li>
                    4. 개인정보보호전담기구의 운영<br />
                    사내 개인정보보호전담기구 등을 통하여 글로싸인엔터프라이즈
                    개인정보취급방침의 이행사항 및 담당자의 준수여부를 확인하여
                    문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록
                    노력하고 있습니다.
                  </li>
                  <li>
                    단,글로싸인엔터프라이즈는 고객 개인적인
                    부주의인엔터프라이즈나 인터넷상의 문제로 아이디, 비밀번호
                    블록체인 비밀번호 등 개인정보가 유출되어 발생한 문제와
                    기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을
                    지지 않습니다. <br />
                    공용PC에서의 로그인시 개인정보가 유출되지 않도록 각별한
                    주의를 기울여 주시기 바랍니다.
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">
                  10. 개인정보 관리책임자 및 담당자의 소속-성명 및 연락처
                </h4>
                <ul class="agree_in">
                  <li>
                    [개인정보 관리책임자]<br />
                    성명 : 한광희<br />
                    소속/직위 : 글로싸인엔터프라이즈 사업총괄<br />
                    E-mail : kenny.han@businesson.co.kr<br />
                    Tel : 02)559-0801<br />
                    Fax : 02)559-0808
                  </li>
                  <li>
                    [개인정보 관리담당자]<br />
                    성명 : 정인수<br />
                    소속/직위 : 글로싸인엔터프라이즈 서비스운영팀/차장<br />
                    E-mail : jisyr@businesson.co.kr<br />
                    Tel : 02)559-0842<br />
                    Fax : 02)559-0808
                  </li>
                </ul>
              </li>
              <li>
                <h4 class="agree_h2">11. 고지의 의무</h4>
                <ul class="agree_in">
                  <li>
                    현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는
                    개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할
                    것입니다.
                  </li>
                  <li>공고일자 : 2022년 10월 5일</li>
                  <li>시행일자 : 2022년 10월 12일</li>
                </ul>
              </li>
            </ul>
          </v-col>
          <!--/[2024년 04월 15일] 이전-->
        </v-row>
      </v-card-text>
      <!--/팝업 내용-->
      <!--팝업 버튼-->
      <v-card-actions class="justify-center">
        <v-btn text @click="intgInfoPop = false">닫기</v-btn>
      </v-card-actions>
      <!--/팝업 버튼-->
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "term",
  components: {},
  filters: {},
  data() {
    return {
      // 다이얼로그
      intgInfoPop: false,
      step0: true,
      step1: false,
      step2: false,
      step3: false,
      termCategory: [
        { text: '이전 개인정보 처리방침 보기', value: 0 },
        { text: '시행일자 : 2022년 10월 12일', value: 3 },
        { text: '시행일자 : 2020년 12월 14일', value: 2 },
        { text: '시행일자 : 2018년 07월 19일', value: 1 },
      ],
      selectTerm: 0,
    };
    
    
  },
  created() {},
  mounted() {},
  methods: {
    click(page) {
      if (page === 0) {
        this.selectTerm = 0;
        this.step0 = true;
        this.step1 = false;
        this.step2 = false;
        this.step3 = false;
      } 
    },
    open() {
      this.intgInfoPop = true;
      this.selectTerm = 0;
      this.click(0);
    },
    changeTerm () {
      this.page = this.selectTerm

      if(this.page === 0) {
        this.step0 = true;
        this.step1 = false;
        this.step2 = false;
        this.step3 = false;
      } else if(this.page === 1) {
        this.step0 = false;
        this.step1 = true;
        this.step2 = false;
        this.step3 = false;
      } else if(this.page === 2) {
        this.step0 = false;
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      } else if(this.page === 3) {
        this.step0 = false;
        this.step1 = false;
        this.step2 = false;
        this.step3 = true;
      }
    },
  }
};
</script>
<style scoped></style>
